import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to `#hash` after navigation (e.g. /services -> /#contact).
 * Scrolls to top when navigating to a route without a hash.
 */
export default function ScrollToHash() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            // Wait for the destination page to mount before scrolling.
            const tryScroll = (attempt = 0) => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                } else if (attempt < 10) {
                    setTimeout(() => tryScroll(attempt + 1), 80);
                }
            };
            tryScroll();
        } else {
            window.scrollTo({ top: 0, behavior: "instant" });
        }
        // `pathname` and `hash` are the only inputs that should trigger this
        // effect. `id`, `el`, `attempt` and the local `tryScroll` recursion
        // are all scoped inside the effect and intentionally re-created on
        // each navigation.
    }, [pathname, hash]);

    return null;
}
